export const SET_WELLNESS_ENTRIES = 'SET_WELLNESS_ENTRIES';
export const SET_WELLNESS_LOADING = 'SET_WELLNESS_LOADING';
export const SET_WELLNESS_ERROR = 'SET_WELLNESS_ERROR';
export const SET_SELECTED_DATE = 'SET_SELECTED_DATE';
export const SET_CURRENT_ENTRY = 'SET_CURRENT_ENTRY';
export const ADD_WELLNESS_ENTRY = 'ADD_WELLNESS_ENTRY';
export const UPDATE_WELLNESS_ENTRY = 'UPDATE_WELLNESS_ENTRY';
export const REMOVE_WELLNESS_ENTRY = 'REMOVE_WELLNESS_ENTRY';
export const SET_FORM_DRAFT = 'SET_FORM_DRAFT';
export const CLEAR_FORM_DRAFT = 'CLEAR_FORM_DRAFT';